import styles from './Service.module.css';
import '../../resources/css/admin_style.css';
import React, {useContext, useEffect, useState} from "react";
import {ModalContext} from "../../utils/modal/ModalProvider";
import {IAM_SERVER_SERVICE} from "../../utils/Config";
import axios from "../../utils/api/axios";
import DetailModal from "../../utils/modal/DetailModal";
import {ServiceDetailModal} from "./modal/ServiceDetailModal";
import {ServiceRegisterModal} from "./modal/ServiceRegisterModal";
import ServiceTable from './component/ServiceTable';
import { useTenantList } from '../../utils/service/tenantList';
import { useInnocodeLoadingOverlay, InnocodeList, InnocodeButton } from '@intsoft/innocode-core';

export const ModalEnum = {
    //기기 관리 Modal Enum
    REGISTER: 'register_one_button',
    DETAIL: 'modify_and_delete_two_button'
}

/**
 * 사용자 관리 화면
 * @param isMobile
 * @param setMovePage
 * @returns {JSX.Element}
 * @constructor
 */
function Service({isMobile, setMovePage}) {
    const { show: showLoading, hide: hideLoading } = useInnocodeLoadingOverlay();
    const {openModal} = useContext(ModalContext);
    const [isMobileWindow, setIsMobileWindow] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileWindow(window.innerWidth < 768); // 모바일 기준 너비
        };
        handleResize(); // 초기값
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    //로그인된 사용자의 테넌트 리스트
    const { tenantList, isLoading: isTenantListLoading } = useTenantList(); // isLoading 상태도 함께 가져옴

    //검색 조건
    const [searchValue, setSearchValue] = useState('');
    const [searchParams, setSearchParams] = useState({ type: '', value: '' });

    //테이블 데이터
    const [cellData, setCellData] = useState([]);
    const [page, setPage] = useState(0);
    const listSize = 10; // 한 페이지당 보여줄 항목 수
    const [totalCount, setTotalCount] = useState(0);

    // 정렬 Custom
    const [sortModel, setSortModel] = React.useState({
        field: "createdDate",   // 현재 정렬 기준값
        sort: "desc",   // (asc: 오름차순, desc: 내림차순)
    });

    //---- 그룹트리 ----//
    const [showGroupTree, setShowGroupTree] = useState(true);
    const [treeData, setTreeData] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState(null);

    useEffect(() => {
        if (!isTenantListLoading && tenantList.length > 0) {
            const transformed = transformToTreeData(tenantList);
            setTreeData(transformed);

            // 페이지 로드 시 첫 번째 테넌트를 기본 선택한다.
            if (!selectedGroup && transformed.length > 0) {
                const firstGroup = transformed[0];
                setSelectedGroup(firstGroup);
            }
        }
    }, [tenantList, isTenantListLoading]); // tenantList 또는 로딩 상태가 변경될 때 실행

    useEffect(() => {
        if (!selectedGroup) {
            return;
        }

        fetchData(selectedGroup.key, page, listSize, searchParams.type, searchParams.value);
    }, [selectedGroup, page, searchParams]);

    const transformToTreeData = (data) => {
        return data.map(item => ({
            title: item.tenantName,
            key: item.tenantId
        }));
    };

    // page 또는 정렬 조건이 바뀔 때마다 Reloading
    // (selectedGroup/page/searchParams 변경 시 위 effect에서 조회)

    //검색 조회
    const handleSearch = async (searchType, value) => {
        if (!selectedGroup) return; // null 체크 추가
        setSearchParams({ type: searchType, value });
        setPage(0);
    }

    // 그룹 선택 핸들러 (InnocodeList용으로 간소화)
    const handleGroupSelect = (group) => {
        setPage(0);

        setSelectedGroup(group);
        setSearchValue('');
        setSearchParams({ type: '', value: '' });

    };
    

    // 데이터 테이블 조회 API
    const fetchData = async (tenantId, page = 0, size = listSize, searchType='', searchValue='') => {
        showLoading();

        try {
            const url = IAM_SERVER_SERVICE + "/all";

            const conditions = [];

            // 선택 조건: 검색 조건 있을 때만 추가
            if (searchType.trim() && searchValue.trim()) {
                conditions.push({
                    field: searchType,
                    operator: "LIKE",
                    value: searchValue
                });
            }

            if (tenantId) {
                conditions.push({ field: "createdBy", operator: "EQUALS", value: tenantId });
            }

            // 최종 params 구성
            const params = {
                page: page,
                size: listSize,
                sortField: [sortModel.field],
                sortOrder: [sortModel.sort],
                operator: "AND",
                conditions
            };

            const res = await axios.post(url, params);

            const { data, recordsTotal } = res.data.data;

            setTotalCount(recordsTotal);
            setCellData(data);

        } catch (error) {
            console.error(error);
        } finally {
            hideLoading();
        }
    }

    // 서비스 등록 모달 핸들러
    const handleRegisterService = () => {
        if (!selectedGroup) {
            return;
        }

        const modalContent = <ServiceRegisterModal tenantId={selectedGroup.key} update={()=>fetchData(selectedGroup.key, page, listSize, searchParams.type, searchParams.value)}/>
        const modalOption = {modalTitle: '서비스 등록'}
        openModal(<DetailModal content={modalContent} option={modalOption} />)
    }

    // 서비스 상세정보 모달 핸들러
    const handleDetailInfo = (data) => {
        if (!selectedGroup) {
            return;
        }
        
        const modalContent = <ServiceDetailModal id={data.serviceId} update={()=>fetchData(selectedGroup.key, page, listSize, searchParams.type, searchParams.value)}/>
        const modalOption = {modalTitle: '서비스 정보'}
        openModal(<DetailModal content={modalContent} option={modalOption} />)
    };



    return (
        <div className={styles.layoutWrapper}>
            <h3>서비스 관리</h3>  
            <div className={styles.contentsWrapper}>
                {showGroupTree && (
                    <div className={styles.sidebar} 
                    style={{ 
                        marginRight: "5px",
                        width: !isMobileWindow ? "250px" : "100px",
                        minWidth: !isMobileWindow ? "200px" : "100px"}}>
                         
                        <div className={styles.groupList}>
                            {treeData.map((group) => (
                                <InnocodeList
                                    key={group.key}
                                    status={selectedGroup?.key === group.key ? 'hover' : 'default'}
                                    className={`${styles.groupItem} ${selectedGroup?.key === group.key ? styles.selected : ''}`}
                                    onClick={() => handleGroupSelect(group)}
                                >
                                    <span className={styles.groupName}>{group.title}</span>
                                </InnocodeList>
                            ))}  

                    </div>
                    </div>
                )}
                <div className={styles.rightCont__cont__tableWrap} style={{ flex: "1" }}>
                    {!showGroupTree && (
                        <div className={styles.sidebarToggleButton}>
                            <InnocodeButton
                                size="md"
                                designType="assistive"
                                theme="opacity"
                                iconOnly={true}
                                onClick={() => setShowGroupTree(true)}
                                icon={
                                    <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m9 5 7 7-7 7"/>
                                    </svg>
                                }
                            />
                        </div>
                    )}
                    <div className={styles.permissionPanel}>
                        <ServiceTable
                        datas={cellData}
                            onAddUser={handleRegisterService}
                            detailUser={handleDetailInfo}
                            onPageChange={setPage}
                            pageNumber={page}
                            totalCount={totalCount}
                            listSize={listSize}
                            searchValue={searchValue}
                            setSearchValue={setSearchValue}
                            onSearch={handleSearch}
                            isMobileWindow={isMobileWindow}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Service;
